export {
  accessRightsApi,
  useApplyAccessRightsTemplateMutation,
  useDeleteAccessRightsTemplateMutation,
  useGetAccessRightsTemplateQuery,
  useGetAccessRightsTemplatesQuery,
  useGetUserAccessRightsQuery,
  useLazyGetAccessRightsTemplateQuery,
  useLazyGetAccessRightsTemplatesQuery,
  useLazyGetUserAccessRightsQuery,
  useUpdateAccessRightsModulesMutation,
  useUpdateAccessRightsTemplateByUserIdMutation,
  useUpdateAccessRightsTemplateMutation,
  useUpdateAccessRightsTemplatesMutation,
  useUpdateUserAccessRightsMutation,
} from './api';

export {
  AccessRightsEndpoints,
  type ApplyAccessRightsTemplateRequest,
  type ApplyAccessRightsTemplateResponse,
  type DeleteAccessRightsTemplateRequest,
  type DeleteAccessRightsTemplateResponse,
  type GetAccessRightsTemplateRequest,
  type GetAccessRightsTemplateResponse,
  type GetAccessRightsTemplatesRequest,
  type GetAccessRightsTemplatesResponse,
  type GetUserAccessRightsRequest,
  type GetUserAccessRightsResponse,
  type ModelAccessRightsTemplate,
  type UpdateAccessRightsModulesRequest,
  type UpdateAccessRightsModulesResponse,
  type UpdateAccessRightsTemplateByUserIdRequest,
  type UpdateAccessRightsTemplateByUserIdResponse,
  type UpdateAccessRightsTemplateRequest,
  type UpdateAccessRightsTemplateResponse,
  type UpdateAccessRightsTemplatesRequest,
  type UpdateAccessRightsTemplatesResponse,
  type UpdateUserAccessRightsRequest,
  type UpdateUserAccessRightsResponse,
} from './types';
